import React, { useEffect, useRef, useState } from 'react';
import icClose from '../images/icons/ic-exit.svg';
import focusLock from 'dom-focus-lock';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function Modal({
  children,
  title,
  open,
  onClose,
  contentContainerClasses = 'w-full',
  modalWidth = 'max-w-md w-full',
  zIndex = 'z-[1100]',
  enableCloseButton = true,
}) {
  const modalRef = useRef(null);

  const [display, setDisplay] = useState(open);

  useEffect(() => {
    if (open) {
      // Display the modal when open is true
      setDisplay(true);
    } else {
      console.log('close', { modalRef });
      if (modalRef.current) {
        // Enabling scroll on body and unlocking focus when modal is closed.
        // This is to prevent scroll on body when modal is open.
        enableBodyScroll(modalRef.current);
        focusLock.off(modalRef.current);
        setDisplay(false);
      }
    }
  }, [open]);

  useEffect(() => {
    // Enable scroll lock when modal is open
    if (display) {
      console.log('display', { modalRef });
      disableBodyScroll(modalRef.current);
      focusLock.on(modalRef.current);
    }
  }, [display]);

  useEffect(() => {
    // Switch off scroll lock when component unmounts
    return () => {
      if (modalRef.current) {
        enableBodyScroll(modalRef.current);
        focusLock.off(modalRef.current);
      }
    };
  }, []);

  // Don't display when closed.
  if (!display) return null;

  const onModalClick = (e) => {
    if (e.target.classList.contains('modal__bg')) {
      onClose();
    }
  };
  return (
    <div
      ref={modalRef}
      className={`${zIndex} fixed top-0 left-0 bottom-0 right-0 bg-background-secondary/60 p-16pt modal__bg overflow-y-auto flex`}
      aria-modal='true'
      role='dialog'
      aria-labelledby='modal-title'
      onClick={onModalClick}
    >
      <div
        className={`bg-background-quaternary p-16pt ${modalWidth} text-text-body rounded-lg m-auto`}
      >
        <div className='flex justify-between items-start mb-8'>
          <div>
            {title ? (
              <h2 id='modal-title' className='mini-label font-medium m-0'>
                {title}
              </h2>
            ) : null}
          </div>
          {enableCloseButton && (
            <button
              aria-label='Close modal'
              className='ml-4 h-auto small-link-text text-text-grey-600 align-middle appearance-none'
              onClick={onClose}
            >
              <span>Close</span>
              <img className='inline-block ml-2' src={icClose} />
            </button>
          )}
        </div>
        <div className={contentContainerClasses}>{children}</div>
      </div>
    </div>
  );
}

export default Modal;
